(() => {
  const initCozyMeowFrame = (root = document) => {
    const shells = root.matches?.('[data-cozymeow-shell]') ? [root] : root.querySelectorAll?.('[data-cozymeow-shell]') || [];
    shells.forEach((shell) => {
      const frame = shell.querySelector('iframe');
      const configNode = shell.querySelector('[data-cozymeow-config]');
      if (!frame || !configNode) return;
      let config;
      try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
      const apply = (doc) => {
        if (!doc?.body) return;
        const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach((node) => {
          let value = node.nodeValue;
          config.replacements.forEach((item) => { if (item.from && value.includes(item.from)) value = value.split(item.from).join(item.to); });
          if (config.product.title && value.includes('The CozyMeow Cat Bed™')) value = value.split('The CozyMeow Cat Bed™').join(config.product.title);
          if (config.product.price && (value.trim() === '$78.89' || value.trim() === '$109.89')) value = value.replace(value.trim(), config.product.price);
          if (value !== node.nodeValue) node.nodeValue = value;
        });
      };
      fetch(frame.dataset.source)
        .then((response) => response.text())
        .then((html) => {
          frame.addEventListener('load', () => {
            const doc = frame.contentDocument;
            apply(doc);
            setTimeout(() => apply(doc), 300);
            setTimeout(() => apply(doc), 1200);
            doc.addEventListener('click', async (event) => {
              const button = event.target.closest('button');
              if (!button || !/add to cart|buy it now/i.test(button.textContent) || !config.product.id) return;
              event.preventDefault(); event.stopImmediatePropagation();
              button.disabled = true;
              try {
                const response = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:config.product.id,quantity:1}]}) });
                if (!response.ok) throw new Error('Cart error');
                window.location.href = '/cart';
              } catch (_) { button.disabled = false; alert('Select an available Shopify product in the theme editor.'); }
            }, true);
          }, { once: true });
          frame.srcdoc = html;
        });
    });
  };
  document.addEventListener('DOMContentLoaded', () => initCozyMeowFrame());
  document.addEventListener('shopify:section:load', (event) => initCozyMeowFrame(event.target));

  let drawer = document.querySelector('[data-cart-drawer]');
  let scrim = document.querySelector('.drawer-scrim');
  const setDrawer = (open) => {
    if (!drawer || !scrim) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    scrim.hidden = !open;
    document.body.classList.toggle('drawer-open', open);
  };
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format(amount / 100);
  const editorCartKey = 'cozzyle-editor-cart-preview';
  const rememberEditorItems = (addedItems = []) => {
    if (!window.Shopify?.designMode || !addedItems.length) return;
    let stored = [];
    try { stored = JSON.parse(sessionStorage.getItem(editorCartKey) || '[]'); } catch (_) { stored = []; }
    addedItems.forEach((item) => {
      const variantId = Number(item.variant_id || item.id);
      const existing = stored.find((line) => Number(line.variant_id) === variantId);
      if (existing) existing.quantity += Number(item.quantity || 1);
      else stored.push({
        key: item.key || String(variantId), variant_id: variantId, product_id: Number(item.product_id),
        product_title: item.product_title || item.title, variant_title: item.variant_title || '',
        quantity: Number(item.quantity || 1), image: item.image || item.featured_image?.url || '',
        price: Number(item.price || item.final_price || 0)
      });
    });
    sessionStorage.setItem(editorCartKey, JSON.stringify(stored));
  };
  const cozyProductId = 7816445788273;
  const cozyVariantIds = { 1: 44384307609713, 2: 44384307642481, 3: 44384307675249 };
  const cozyUnits = (item) => {
    if (Number(item.product_id) !== cozyProductId) return 0;
    if (Number(item.variant_id) === cozyVariantIds[3]) return item.quantity * 3;
    if (Number(item.variant_id) === cozyVariantIds[2]) return item.quantity * 2;
    return item.quantity;
  };
  const setCozyQuantity = async (quantity) => {
    const total = Math.max(0, Number(quantity) || 0);
    const updates = { [cozyVariantIds[1]]: 0, [cozyVariantIds[2]]: 0, [cozyVariantIds[3]]: 0 };
    updates[cozyVariantIds[3]] = Math.floor(total / 3);
    const remainder = total % 3;
    if (remainder === 2) updates[cozyVariantIds[2]] = 1;
    if (remainder === 1) updates[cozyVariantIds[1]] = 1;
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    if (!response.ok) throw new Error('Unable to update the cart.');
    return response.json();
  };
  const refreshDrawer = async (addedItems = []) => {
    rememberEditorItems(addedItems);
    let cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
    if (window.Shopify?.designMode && !cart.item_count) {
      let previewItems = [];
      try { previewItems = JSON.parse(sessionStorage.getItem(editorCartKey) || '[]'); } catch (_) { previewItems = []; }
      if (previewItems.length) {
        previewItems = previewItems.map((item) => ({ ...item, final_line_price: item.price * item.quantity }));
        cart = { items: previewItems, item_count: previewItems.reduce((sum, item) => sum + item.quantity, 0), total_price: previewItems.reduce((sum, item) => sum + item.final_line_price, 0), currency: window.Shopify?.currency?.active || 'USD' };
      }
    }
    const cozyItems = cart.items.filter((item) => Number(item.product_id) === cozyProductId);
    const regularItems = cart.items.filter((item) => Number(item.product_id) !== cozyProductId);
    const cozyQuantity = cozyItems.reduce((sum, item) => sum + cozyUnits(item), 0);
    const visibleCount = regularItems.reduce((sum, item) => sum + item.quantity, 0) + cozyQuantity;
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = visibleCount; });
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    if (!cart.item_count) body.innerHTML = '<div class="empty-cart"><span>🐾</span><p>Your bag is waiting for something cozy.</p></div>';
    else {
      const threshold = Number(drawer?.dataset.shippingThreshold || 10000);
      const remaining = Math.max(0, threshold - cart.total_price);
      const progress = Math.min(100, cart.total_price / threshold * 100);
      const cozyLine = cozyQuantity ? `<div class="cart-line" data-cozy-cart-line>${cozyItems[0].image ? `<img src="${cozyItems[0].image}" alt="">` : ''}<div><strong>${cozyItems[0].product_title}</strong><small>${cozyQuantity} ${cozyQuantity === 1 ? 'bed' : 'beds'}</small><div class="drawer-line-bottom"><span>${money(cozyItems.reduce((sum,item)=>sum+item.final_line_price,0), cart.currency)}</span><div><button type="button" data-cozy-drawer-qty="${Math.max(0,cozyQuantity-1)}">−</button><b>${cozyQuantity}</b><button type="button" data-cozy-drawer-qty="${cozyQuantity+1}">+</button></div></div></div></div>` : '';
      const timerText = drawer?.dataset.timerText || 'Your cart is reserved for';
      const reviewsText = drawer?.dataset.reviewsText || '★★★★★ 4.9/5 · 1,700+ verified reviews';
      const buyersText = drawer?.dataset.buyersText || 'Sarah, Maddie, Tyler and 1,026 others ordered';
      const addShipping = drawer?.dataset.addShipping || 'Add';
      const shippingUnlocked = drawer?.dataset.shippingUnlocked || 'You unlocked Free Shipping!';
      const shippingProgress = drawer?.dataset.shippingProgress || 'to unlock Free Shipping';
      const discountLabel = drawer?.dataset.discountLabel || 'Discount code';
      const discountButton = drawer?.dataset.discountButton || 'Apply';
      const subtotalText = drawer?.dataset.subtotalText || 'Subtotal';
      const checkoutText = drawer?.dataset.checkoutText || 'VIEW BAG & CHECKOUT';
      body.innerHTML = `<div class="drawer-reserve">${timerText} <strong data-drawer-timer>00:${drawer?.dataset.drawerMinutes || 37}:00</strong></div><div class="drawer-proof"><strong>${reviewsText}</strong><span>${buyersText}</span></div>` + cozyLine + regularItems.map((item) => `<div class="cart-line" data-cart-line="${item.key}">${item.image ? `<img src="${item.image}" alt="">` : ''}<div><strong>${item.product_title}</strong><small>${item.variant_title || ''}</small><div class="drawer-line-bottom"><span>${money(item.final_line_price, cart.currency)}</span><div><button type="button" data-drawer-qty="${Math.max(0,item.quantity-1)}" data-line-key="${item.key}">−</button><b>${item.quantity}</b><button type="button" data-drawer-qty="${item.quantity+1}" data-line-key="${item.key}">+</button></div></div></div></div>`).join('') + `<div class="drawer-shipping"><p>${remaining ? `${addShipping} <strong>${money(remaining,cart.currency)}</strong> ${shippingProgress}` : shippingUnlocked}</p><div><i style="width:${progress}%"></i><b>🚚</b></div></div><div class="drawer-discount"><label for="drawer-discount">${discountLabel}</label><div><input id="drawer-discount" type="text" placeholder="${discountLabel}" data-drawer-discount><button type="button" data-drawer-discount-apply>${discountButton}</button></div><small data-drawer-discount-status></small></div><div class="cart-total"><span>${subtotalText}</span><strong>${money(cart.total_price, cart.currency)}</strong></div><a class="button button--wide drawer-checkout" href="${window.Shopify.routes.root}cart">${checkoutText} — ${money(cart.total_price,cart.currency)}</a>`;
      startDrawerTimer();
    }
  };
  const startDrawerTimer = () => {
    if (!drawer) return;
    const key = 'cozymeow-drawer-reserved-until';
    let end = Number(sessionStorage.getItem(key));
    if (!end || end < Date.now()) { end = Date.now() + Number(drawer.dataset.drawerMinutes || 37) * 60000; sessionStorage.setItem(key, String(end)); }
    clearInterval(window.cozyDrawerTimer);
    const tick = () => { const timer = drawer.querySelector('[data-drawer-timer]'); if (!timer) return; const left = Math.max(0,end-Date.now()), m=Math.floor(left/60000), s=Math.floor(left%60000/1000); timer.textContent=`00:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`; };
    tick(); window.cozyDrawerTimer = setInterval(tick,1000);
  };
  document.addEventListener('shopify:section:load', (event) => {
    const loadedDrawer = event.target.querySelector?.('[data-cart-drawer]');
    if (!loadedDrawer) return;
    drawer = loadedDrawer;
    scrim = document.querySelector('.drawer-scrim');
    refreshDrawer().then(() => setDrawer(true));
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mobile-menu-open]')) { const menu = document.querySelector('[data-mobile-menu]'); if (menu) menu.hidden = false; document.body.classList.add('drawer-open'); }
    if (event.target.closest('[data-mobile-menu-close]') || (event.target.matches('[data-mobile-menu]'))) { const menu = document.querySelector('[data-mobile-menu]'); if (menu) menu.hidden = true; document.body.classList.remove('drawer-open'); }
    if (event.target.closest('[data-cart-open]')) setDrawer(true);
    if (event.target.closest('[data-cart-close]')) setDrawer(false);
    const drawerQty = event.target.closest('[data-drawer-qty]');
    if (drawerQty) { drawerQty.disabled = true; fetch(window.Shopify.routes.root + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:drawerQty.dataset.lineKey,quantity:Number(drawerQty.dataset.drawerQty)})}).then(refreshDrawer).catch(()=>{drawerQty.disabled=false;}); }
    const cozyDrawerQty = event.target.closest('[data-cozy-drawer-qty]');
    if (cozyDrawerQty) { cozyDrawerQty.disabled = true; setCozyQuantity(cozyDrawerQty.dataset.cozyDrawerQty).then(refreshDrawer).catch(()=>{cozyDrawerQty.disabled=false;}); }
    const drawerDiscount = event.target.closest('[data-drawer-discount-apply]');
    if (drawerDiscount) { const input=drawer.querySelector('[data-drawer-discount]'),status=drawer.querySelector('[data-drawer-discount-status]'),code=input.value.trim(); if(!code){status.textContent='Enter a discount code.';}else{status.textContent='Applying…';window.location.href=`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;} }
    const filter = event.target.closest('[data-review-filter]');
    if (filter) {
      document.querySelectorAll('[data-review-filter]').forEach((button) => button.classList.toggle('is-active', button === filter));
      document.querySelectorAll('[data-review-card]').forEach((card) => { card.hidden = filter.dataset.reviewFilter !== 'All' && card.dataset.reviewCard !== filter.dataset.reviewFilter; });
    }
    const copy = event.target.closest('[data-copy-code]');
    if (copy) { navigator.clipboard?.writeText(copy.dataset.copyCode); copy.textContent = 'Copied!'; setTimeout(() => { copy.textContent = 'Copy'; }, 1500); }
    if (event.target.closest('[data-discount-close]')) { const pop = document.querySelector('[data-discount-pop]'); if (pop) pop.hidden = true; sessionStorage.setItem('cozymeow-pop-closed','1'); }
    const thumb = event.target.closest('[data-media-target]');
    if (thumb) {
      const root = thumb.closest('[data-product-section]');
      root.querySelectorAll('[data-media]').forEach((item) => item.classList.toggle('is-active', item.dataset.media === thumb.dataset.mediaTarget));
      root.querySelectorAll('[data-media-target]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    }
  });
  startDrawerTimer();
  if (drawer) refreshDrawer();
  setTimeout(() => { const pop = document.querySelector('[data-discount-pop]'); if (pop && !sessionStorage.getItem('cozymeow-pop-closed')) pop.hidden = false; }, 12000);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = select.closest('[data-product-section]').querySelector('[data-product-price]');
      if (price) price.textContent = option.dataset.price;
    });
  });
  document.querySelectorAll('[data-variant-radio]').forEach((radio) => {
    radio.addEventListener('change', () => {
      const root = radio.closest('[data-product-section]');
      root.querySelectorAll('.cm-variant').forEach((item) => item.classList.toggle('is-selected', item.contains(radio) && radio.checked));
      root.querySelectorAll('[data-product-price]').forEach((price) => { price.textContent = radio.dataset.price; });
      root.querySelectorAll('[data-product-compare]').forEach((compare) => { compare.textContent = radio.dataset.compare || ''; compare.hidden = !radio.dataset.compare; });
      root.querySelectorAll('[data-product-save]').forEach((save) => { save.textContent = radio.dataset.save || ''; save.hidden = !radio.dataset.save; });
      updateProductTotal(root);
    });
  });
  const updateProductTotal = (root) => {
    if (!root) return;
    const selected = root.querySelector('[data-variant-radio]:checked') || root.querySelector('[name="id"]');
    let total = Number(selected?.dataset.priceCents || 0);
    root.querySelectorAll('[data-addon-variant]:checked').forEach((addon) => { total += Number(addon.dataset.addonPrice || 0); });
    const output = root.querySelector('[data-product-total]');
    if (output) output.textContent = money(total, root.dataset.currency);
  };
  document.querySelectorAll('[data-product-section]').forEach((root) => {
    root.querySelectorAll('[data-addon-variant]').forEach((addon) => addon.addEventListener('change', () => updateProductTotal(root)));
    updateProductTotal(root);
  });
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      try {
        const selectedVariant = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
        const items = [{ id: Number(selectedVariant.value), quantity: 1 }];
        form.querySelectorAll('[data-addon-variant]:checked').forEach((addon) => { items.push({ id: Number(addon.value), quantity: 1 }); });
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Unable to add this item.');
        const added = await response.json();
        await refreshDrawer(added.items || []);
        setDrawer(true);
      } catch (error) { alert(error.message); }
      finally { button.disabled = false; }
    });
  });
})();
